import React from "react";

function DomainIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.399902 9.9999C0.399902 7.45382 1.41133 5.01203 3.21168 3.21168C5.01203 1.41133 7.45382 0.399902 9.9999 0.399902V9.9999H19.5999C19.5999 12.546 18.5885 14.9878 16.7881 16.7881C14.9878 18.5885 12.546 19.5999 9.9999 19.5999C7.45382 19.5999 5.01203 18.5885 3.21168 16.7881C1.41133 14.9878 0.399902 12.546 0.399902 9.9999Z"
        fill="#333333"
      />
    </svg>
  );
}

export default DomainIcon;
